import { render, staticRenderFns } from "./px-navbar-wizard.vue?vue&type=template&id=59af6778&scoped=true&"
import script from "./px-navbar-wizard.vue?vue&type=script&lang=ts&"
export * from "./px-navbar-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./px-navbar-wizard.vue?vue&type=style&index=0&id=59af6778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af6778",
  null
  
)

export default component.exports